"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.phoneField = exports.infoField = exports.nameField = exports.emailField = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formik = require("formik");

var _input = _interopRequireDefault(require("react-phone-number-input/input"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// Note: Using FastField as these fields don't rely on each other's values.
// https://jaredpalmer.com/formik/docs/api/fastfield

/**
 * Email input field component. To be used with componentSubstitution.
 * @returns {function} A function meant to be passed to componentSubstitutions.
 */
var emailField = function emailField(placeholder) {
  return /*#__PURE__*/_react["default"].createElement("span", {
    key: "email",
    className: "inputField"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "errorMessage"
  }, /*#__PURE__*/_react["default"].createElement(_formik.ErrorMessage, {
    name: "email"
  })), /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    className: "input",
    type: "email",
    name: "email",
    placeholder: placeholder
  }));
};
/**
 * Name input field component. To be used with componentSubstitution.
 * @returns {function} A function meant to be passed to componentSubstitutions.
 */


exports.emailField = emailField;

var nameField = function nameField(placeholder) {
  return /*#__PURE__*/_react["default"].createElement("span", {
    key: "name",
    className: "inputField"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "errorMessage"
  }, /*#__PURE__*/_react["default"].createElement(_formik.ErrorMessage, {
    name: "name"
  })), /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    className: "input",
    type: "text",
    name: "name",
    placeholder: placeholder
  }));
};
/**
 * Info text area component. To be used with componentSubstitution. Use for longform text answers.
 * @returns {function} A function meant to be passed to componentSubstitutions.
 */


exports.nameField = nameField;

var infoField = function infoField(placeholder) {
  return /*#__PURE__*/_react["default"].createElement("span", {
    key: "info",
    className: "inputField textarea"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "errorMessage"
  }, /*#__PURE__*/_react["default"].createElement(_formik.ErrorMessage, {
    name: "info"
  })), /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    className: "input",
    component: "textarea",
    name: "info",
    rows: "3",
    placeholder: placeholder
  }));
};
/**
 * Custom Formik field. Formats phone number input as a user types
 * https://formik.org/docs/api/field#component
 */


exports.infoField = infoField;

var CustomPhoneInput = function CustomPhoneInput(_ref) {
  var field = _ref.field,
      form = _ref.form,
      props = _objectWithoutProperties(_ref, ["field", "form"]);

  var onChange = field.onChange,
      name = field.name,
      value = field.value,
      fieldRest = _objectWithoutProperties(field, ["onChange", "name", "value"]);

  var setFieldValue = form.setFieldValue;
  var onPhoneInputChange = (0, _react.useCallback)(function (phoneInputValue) {
    return setFieldValue(name, phoneInputValue);
  });
  return /*#__PURE__*/_react["default"].createElement(_input["default"], _extends({
    defaultCountry: "US",
    onChange: onPhoneInputChange,
    name: name
  }, fieldRest, props));
};

CustomPhoneInput.propTypes = {
  field: _propTypes["default"].object.isRequired,
  // eslint-disable-line
  form: _propTypes["default"].object.isRequired // eslint-disable-line

};
/**
 * Phone number input component. To be used with componentSubstitution. Use for phone numbers
 * @returns {function} A function meant to be passed to componentSubstitutions.
 */

var phoneField = function phoneField(placeholder) {
  return /*#__PURE__*/_react["default"].createElement("span", {
    key: "phone",
    className: "inputField"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "errorMessage"
  }, /*#__PURE__*/_react["default"].createElement(_formik.ErrorMessage, {
    name: "phone"
  })), /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    className: "input",
    component: CustomPhoneInput,
    name: "phone",
    placeholder: placeholder
  }));
};

exports.phoneField = phoneField;